import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function useDebounce(value, delay, relatedDebouncedFunction) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            const handler = setTimeout(() => {
                ReactDOM.unstable_batchedUpdates(() => {
                    setDebouncedValue(value);
                    if(relatedDebouncedFunction){
                        relatedDebouncedFunction();
                    }
                });
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        },
        [value]
    );

    return debouncedValue;
}
